import { stagingAreaApi } from "./stagingArea";

export const { useGetStagingAreasQuery } = stagingAreaApi;
